import katex from 'katex';

const katexClassName = 'math';

function processShortcodes() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
  const textNodes = [];

  let node = walker.nextNode();

  while (node) {
    if (node.textContent.includes('[katex]')) {
      textNodes.push(node);
    }

    node = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    const content = textNode.textContent;
    const mathRegex = /\[katex\](.*?)\[\/katex\]/g;

    if (mathRegex.test(content)) {
      const parent = textNode.parentNode;
      const fragment = document.createDocumentFragment();

      let lastIndex = 0;
      mathRegex.lastIndex = 0;
      let match = mathRegex.exec(content);

      while (match !== null) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(content.slice(lastIndex, match.index)));
        }

        const mathSpan = document.createElement('span');

        mathSpan.className = katexClassName;
        mathSpan.textContent = match[1];

        fragment.appendChild(mathSpan);

        lastIndex = match.index + match[0].length;
        match = mathRegex.exec(content);
      }

      if (lastIndex < content.length) {
        fragment.appendChild(document.createTextNode(content.slice(lastIndex)));
      }

      parent.replaceChild(fragment, textNode);
    }
  });
}

function initKaTeX() {
  processShortcodes();

  const mathElements = document.querySelectorAll(`.${katexClassName}`);

  mathElements.forEach((element) => {
    try {
      const mathText = element.textContent;
      const isDisplayMode = element.classList.contains(`${katexClassName}-display`);

      katex.render(mathText, element, {
        displayMode: isDisplayMode,
        throwOnError: false,
      });
    } catch (error) {
      console.warn('KaTeX rendering error:', error);
    }
  });
}

window.addEventListener('DOMContentLoaded', initKaTeX);
